import { Link } from "react-router-dom";
import { Calendar, Tag } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import LazyImage from "@/components/ui/LazyImage";

interface BlogCardProps {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  featuredImage?: string;
  publishedDate: string;
  category: string;
}

export const BlogCard = ({
  title,
  slug,
  excerpt,
  featuredImage,
  publishedDate,
  category,
}: BlogCardProps) => {
  const formattedDate = new Date(publishedDate).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <Link to={`/blog/${slug}`} className="group">
      <Card className="h-full overflow-hidden transition-all hover:shadow-lg">
        {featuredImage && (
          <div className="overflow-hidden aspect-video">
            <LazyImage
              src={featuredImage}
              alt={`${title} - ${category} cleaning tips for Ventura County`}
              className="w-full h-full object-cover transition-transform group-hover:scale-105"
            />
          </div>
        )}
        <CardHeader>
          <div className="flex items-center gap-2 mb-2">
            <Badge variant="secondary" className="flex items-center gap-1">
              <Tag className="w-3 h-3" />
              {category}
            </Badge>
            <span className="flex items-center gap-1 text-sm text-muted-foreground">
              <Calendar className="w-3 h-3" />
              {formattedDate}
            </span>
          </div>
          <CardTitle className="group-hover:text-primary transition-colors">
            {title}
          </CardTitle>
          <CardDescription>{excerpt}</CardDescription>
        </CardHeader>
        <CardContent>
          <span className="text-primary font-medium">Read More →</span>
        </CardContent>
      </Card>
    </Link>
  );
};
